import React from 'react';

const ProductCardImageComingSoon = () => (
  <img
    alt=""
    className="absolute w-[80%] max-w-full h-[80%] max-h-full top-[10%] left-[10%] object-contain"
    src="/static/assets/icons/image-coming-soon.svg"
  />
);

export default ProductCardImageComingSoon;
